// https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key

export enum KeyboardEventKeys {
  DOWN = 'Down', // IE/Edge specific value
  ARROW_DOWN = 'ArrowDown',
  UP = 'Up', // IE/Edge specific value
  ARROW_UP = 'ArrowUp',
  LEFT = 'Left', // IE/Edge specific value
  ARROW_LEFT = 'ArrowLeft',
  RIGHT = 'Right', // IE/Edge specific value
  ARROW_RIGHT = 'ArrowRight',
  ENTER = 'Enter',
  ESC = 'Esc', // IE/Edge specific value
  ESCAPE = 'Escape',
  BACKSPACE = 'Backspace',
  DELETE = 'Delete',
  SPACE = ' ',
  TAB = 'Tab'
}
